import { useLang } from "@/i18n/LanguageContext";
import { sectionImages } from "@/data/media";
import { ArrowUpRight } from "lucide-react";

const Services = () => {
  const { t } = useLang();
  const items = t("services.items");
  const images = [sectionImages.powderCoating, sectionImages.sandblasting];

  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative bg-[#0a0a0a] py-24 md:py-32 border-t border-[#1f1f1f]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <span className="w-10 h-px bg-[#dc2626]" />
              <p className="font-mono text-xs tracking-[0.3em] uppercase text-[#dc2626]">
                {t("services.tag")}
              </p>
            </div>
            <h2 className="font-display font-black uppercase tracking-tighter text-3xl md:text-5xl lg:text-6xl leading-[0.95] max-w-3xl">
              {t("services.heading")}
            </h2>
          </div>
          <p className="font-mono text-[10px] md:text-xs tracking-[0.3em] uppercase text-[#52525b]">
            02 / 02 · {new Date().getFullYear()}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-px bg-[#1f1f1f]">
          {items.map((s, i) => (
            <article
              key={i}
              data-testid={`service-card-${i}`}
              className="group relative bg-[#0a0a0a] p-8 md:p-12 hover:bg-[#0e0e0e] transition-colors min-h-[420px] flex flex-col"
            >
              <div className="flex items-start justify-between mb-8">
                <span className="font-mono text-xs tracking-[0.3em] text-[#52525b]">
                  / {s.code}
                </span>
                <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#dc2626] border border-[#dc2626]/40 px-2 py-1">
                  {s.tag}
                </span>
              </div>

              <div className="aspect-[16/9] overflow-hidden mb-8 border border-[#1f1f1f]">
                <img
                  src={images[i % images.length]}
                  alt={s.title}
                  className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700"
                />
              </div>

              <h3 className="font-display font-bold uppercase tracking-tight text-2xl md:text-3xl mb-4">
                {s.title}
              </h3>
              <p className="text-sm md:text-base text-[#a1a1aa] leading-relaxed max-w-xl">
                {s.desc}
              </p>

              <a
                href="#contact"
                className="inline-flex items-center gap-2 mt-auto pt-8 text-xs font-mono uppercase tracking-[0.2em] text-[#a1a1aa] group-hover:text-[#dc2626] transition-colors"
              >
                Wyceń <ArrowUpRight className="w-4 h-4" />
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
